import React from "react";
import PdfDocumentTable from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import impactEvaluation201112Pdf from "../../../../assets/tenders/resource/impact_evaluation_study/Impact Evaluation Study for the beneficiaries financed under Term Loan and Micro Finance schemes of NMDFC during 2011-12.pdf";
import impactStudy2021MdiPdf from "../../../../assets/tenders/resource/impact_evaluation_study/Impact Study Report 2021 conducted by MDI.pdf";
import socioEconomicImpactStudy2023Pdf from "../../../../assets/tenders/resource/impact_evaluation_study/NMDFC - Socio economic impact study (Report-2023).pdf";
import reportOneBeneficiaries201416Pdf from "../../../../assets/tenders/resource/impact_evaluation_study/Report 1 of Benefs. financed FY 2014-16.pdf";
import ngosImpactAssessmentPdf from "../../../../assets/tenders/resource/impact_evaluation_study/Report on Assessment of Impact of NMDFC Programmes Financed through NGOs.pdf";
import reportTwoBeneficiaries201416Pdf from "../../../../assets/tenders/resource/impact_evaluation_study/Report2 of Benefs. financed FY 2014-16.pdf";
import verificationTermLoanMicroFinance201213Pdf from "../../../../assets/tenders/resource/impact_evaluation_study/Verification of beneficiaries financed under Term Loan and Micro Finance schemes of NMDFC during 2012-13.pdf";
import verificationCreditBasedSchemes201314Pdf from "../../../../assets/tenders/resource/impact_evaluation_study/Verification of Benificiary of Credit based schemes 2013-14.pdf";

const impactEvaluationStudyDocuments = [
  {
    serial: 1,
    title: "Socio economic impact study (Report-2023)",
    fileName: "NMDFC - Socio economic impact study (Report-2023).pdf",
    href: socioEconomicImpactStudy2023Pdf,
  },
  {
    serial: 2,
    title: "Impact Study Report 2021 conducted by MDI",
    fileName: "Impact Study Report 2021 conducted by MDI.pdf",
    href: impactStudy2021MdiPdf,
  },
  {
    serial: 3,
    title:
      "Impact Study Report of Beneficiaries financed during FY 2014-16 and Indirect Employment generated after Intervention (Report 1)",
    fileName: "Report 1 of Benefs. financed FY 2014-16.pdf",
    href: reportOneBeneficiaries201416Pdf,
  },
  {
    serial: 4,
    title:
      "Impact Study Report of Beneficiaries financed during FY 2014-16 and Indirect Employment generated after Intervention (Report 2)",
    fileName: "Report2 of Benefs. financed FY 2014-16.pdf",
    href: reportTwoBeneficiaries201416Pdf,
  },
  {
    serial: 5,
    title:
      "Verification of Beneficiary of Credit based schemes implemented during 2013-14",
    fileName: "Verification of Benificiary of Credit based schemes 2013-14.pdf",
    href: verificationCreditBasedSchemes201314Pdf,
  },
  {
    serial: 6,
    title:
      "Verification of beneficiaries financed under Term Loan and Micro Finance schemes during 2012-13",
    fileName:
      "Verification of beneficiaries financed under Term Loan and Micro Finance schemes of NMDFC during 2012-13.pdf",
    href: verificationTermLoanMicroFinance201213Pdf,
  },
  {
    serial: 7,
    title:
      "Impact Evaluation Study for the beneficiaries financed under Term Loan and Micro Finance schemes during 2011-12",
    fileName:
      "Impact Evaluation Study for the beneficiaries financed under Term Loan and Micro Finance schemes of NMDFC during 2011-12.pdf",
    href: impactEvaluation201112Pdf,
  },
  {
    serial: 8,
    title: "Report on Assessment of Impact of Programmes Financed through NGOs",
    fileName:
      "Report on Assessment of Impact of NMDFC Programmes Financed through NGOs.pdf",
    href: ngosImpactAssessmentPdf,
  },
];

const ImpactEvaluationStudy = () => (
  <section className="min-w-0 flex-1">
    <h2 className="mb-3 text-[18px] font-bold text-[#005856]">
      Impact Evaluation Study
    </h2>
    <PdfDocumentTable
      documents={impactEvaluationStudyDocuments}
      minWidth="860px"
    />
  </section>
);

export default ImpactEvaluationStudy;
